import { render, staticRenderFns } from "./Station.vue?vue&type=template&id=87d29182&scoped=true"
import script from "./Station.vue?vue&type=script&lang=js"
export * from "./Station.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d29182",
  null
  
)

export default component.exports